import angular from "../assets/angular.svg";
import react from "../assets/react.svg";
import typescript from "../assets/typescript.svg";
import ionic from "../assets/ionic.svg";
import figma from "../assets/figma.svg";
import capacitor from "../assets/capacitor.svg";
import cordova from "../assets/cordova.svg";
import jasmine from "../assets/jasmine.svg";
import rxjs from "../assets/rxjs.svg";
import html from "../assets/html.svg";
import css from "../assets/css.svg";
import javascript from "../assets/javascript.svg";
import scss from "../assets/scss.svg";

export const TECHNOLOGIES = [
  {
    name: "Angular",
    imageSource: angular,
  },
  {
    name: "React",
    imageSource: react,
  },
  {
    name: "Typescript",
    imageSource: typescript,
  },
  {
    name: "Ionic",
    imageSource: ionic,
  },
  {
    name: "Figma",
    imageSource: figma,
  },
  {
    name: "Capacitor",
    imageSource: capacitor,
  },
  {
    name: "Cordova",
    imageSource: cordova,
  },
  {
    name: "Jasmine",
    imageSource: jasmine,
  },
  {
    name: "RxJS",
    imageSource: rxjs,
  },
  {
    name: "HTML",
    imageSource: html,
  },
  {
    name: "CSS",
    imageSource: css,
  },
  {
    name: "JavaScript",
    imageSource: javascript,
  },
  {
    name: "SCSS",
    imageSource: scss,
  },
];
